<template>
  <div class="p-4 shadow flex flex-col justify-start gap-4 w-80">
    <SelectInput
      :model-value="technicianId"
      label="Technician"
      :options="techOptions"
      placeholder="Auto Assign"
      :body-render="false"
      :filter="true"
      filter-placeholder="Search technicians..."
      @update:modelValue="update"
    />
    <Button label="Save" class="w-full" @click="handleSave" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

import Button from "@/components/Seranova/Buttons/Button.vue";
import SelectInput from "@/components/Seranova/SelectInput/SelectInput.vue";
import { fullName } from "@/mixins";
import { AppointmentV2 } from "@/typings/appointment";
import { Technician } from "@/typings/technician";

const emit = defineEmits(["saved"]);
const store = useStore();
const props = defineProps<{ appointment: AppointmentV2 }>();
onMounted(() => {
  if (store.state.technicians.length === 0) {
    store.dispatch("fetchTechnicians");
  }
});
const techOptions = computed(() =>
  store.state.technicians.map((tech: Technician) => ({
    label: fullName(tech),
    value: tech.technician_profile_id
  }))
);
const technicianId = ref(props.appointment?.technician?.technician_id);
const update = (val) => {
  technicianId.value = val;
};
const handleSave = async () => {
  await store.dispatch("assignAppointmentEvent", {
    appointmentId: props.appointment.id,
    technician_profile_id: technicianId.value
  });
  window.notify.success("Appointment technician updated");
  emit("saved");
  tippy.hideAll();
};
</script>

<style lang="scss" scoped></style>
